/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  function replaceWinehubButton() {
    var subscriptionModule = document.querySelector('.subscription-module');
    if (!subscriptionModule) return;

    var originalLink = subscriptionModule.querySelector('a[href="/apps/winehub/wineclub"]');
    if (originalLink && originalLink.parentNode) {
      // Make sure we don’t duplicate the new link
      if (subscriptionModule.querySelector('a[href="/pages/wine-club"]')) return;

      // Create new link
      var newLink = document.createElement('a');
      newLink.setAttribute('href', '/pages/wine-club');
      newLink.className = 'btn btn--solid btn--primary';
      newLink.innerHTML = '<span>Go back to clubs list</span>';

      // Replace the old link entirely
      originalLink.parentNode.replaceChild(newLink, originalLink);

      console.log('✅ Replaced Winehub club button');
    }
  }

  // ===========================
  // Instafeed "Follow us" logic
  // ===========================
  function insertFollowButton() {
    var target = document.querySelector('#insta-feed');
    if (!target) return;

    var heading = target.querySelector('h2');
    if (!heading) return;

    // Check if the wrapper is already there
    if (target.querySelector('.instafeed-heading-wrapper')) return;

    // Create follow button
    var followButton = document.createElement('a');
    followButton.id = 'insta-btn-follow';
    followButton.className = 'btn';
    followButton.href = 'https://www.instagram.com/juniperwinery/';
    followButton.target = '_blank';
    followButton.innerText = 'Follow us';

    // Wrap the heading and follow button
    var wrapper = document.createElement('div');
    wrapper.className = 'instafeed-heading-wrapper';

    // Insert wrapper before heading
    heading.parentNode.insertBefore(wrapper, heading);

    // Append elements
    wrapper.appendChild(heading);
    wrapper.appendChild(followButton);

    console.log('✅ Added Instafeed follow button and wrapper');
  }

  function enableMobileGridHover() {
    const gridItems = document.querySelectorAll('.grid-item');

    gridItems.forEach((item) => {
      const quickAdd = item.querySelector('quick-add-product');
      if (!quickAdd) return;

      const link = item.querySelector('a.product-link');
      if (!link) return;

      let tappedOnce = false;
      let tapTimeout;

      item.addEventListener('touchstart', function (e) {
        const isInteractive = e.target.closest('button, input, select, label, textarea');
        if (isInteractive) return;

        const isInsideOverlay = e.target.closest('.mobile-overlay-click');
        if (!isInsideOverlay) {
          // Not inside the allowed clickable area, don't do anything
          return;
        }

        e.preventDefault(); // Prevent link from being followed

        if (!item.classList.contains('is-hovered')) {
          // First tap: activate hover
          document.querySelectorAll('.grid-item.is-hovered').forEach((el) =>
            el.classList.remove('is-hovered')
          );
          item.classList.add('is-hovered');
          tappedOnce = true;

          clearTimeout(tapTimeout);
          tapTimeout = setTimeout(() => {
            tappedOnce = false;
          }, 1000);
        } else {
          // Second tap: remove hover
          item.classList.remove('is-hovered');
        }
      });

      // Prevent the link from triggering on touch if it's not inside .mobile-overlay-click
      link.addEventListener('click', function (e) {
        const isInsideOverlay = e.target.closest('.mobile-overlay-click');
        if (!isInsideOverlay) {
          e.preventDefault();
        }
      });
    });
  }


  // Dismiss on tap outside
  document.body.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.grid-item')) {
      gridItems.forEach((el) => el.classList.remove('is-hovered'));
    }
  });

  // Run once initially
  replaceWinehubButton();
  insertFollowButton();
  enableMobileGridHover();

  // Observe for future changes
  var observer = new MutationObserver(function (mutations) {
    replaceWinehubButton();
    insertFollowButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
